<template>
  <div>
    <MainNavigation
      v-if="currentClass"
      page-name="Session" 
      :routeIndex="routeIndex"
      :currentClass="currentClass"
      />
    <Loader v-if="!currentClass && !currentSession" />
    <LoaderError v-if="currentClass && !currentSession" />
    <section v-if="currentSession && currentClass">
      <h1 style="display: flex; justify-content: center;">Session: {{getDate(currentSession.startTime)}}</h1>
      <div class="session-container">
        <ClassItem 
           v-if="currentClass"
           :editMode="false"
           :classItem="currentClass"
           :itemType="'static session-block'"
        />
        <div class="session-block">
          <div class="content">
            <h2>Details</h2>
            <p>{{storyBoxName}}
            <br>{{levelName}}</p>
            <p v-if="currentSession.sessionSettings.isTimeLimitEnabled">Time Limit: {{currentSession.sessionSettings.timeLimit}} minutes</p>
            <p v-if="!currentSession.sessionSettings.isTimeLimitEnabled">No Time Limit</p>
            <p></p>
            <p class="date-time">
              <em>
                Start {{getDate(currentSession.startTime)}} {{getTime(currentSession.startTime)}}<br>
                End {{getDate(currentSession.endTime)}} {{getTime(currentSession.endTime)}}
              </em>
            </p>
          </div>
        </div>
        <div class="session-block">
          <div class="content">
            <h2>Attendance</h2>
            <RadialChart 
              :studentList="currentSession.studentList"
              :groupList="attendance"
              v-bind:chart-styles="'test'" 
            />
          </div>
        </div>
        <div  v-if="taskProgressObject.length > 0"  class="session-block">
          <AverageCFUCompletion 
              :taskProgress="taskProgressObject"
              :groupLength="groupList.length"
            />
        </div>
        <div v-if="taskProgressObject.length > 0" class="session-block average-time">
          <div class="content">
            <h2>Average Time per Section</h2>
            <AverageBarChart 
              v-bind:chart-styles="'test'" 
              :groupLength="groupList.length"
              :taskProgress="taskProgressObject"
            />
          </div>
        </div>
      </div>
      <!-- <h1>Report Card</h1>
      <div class="session-container">
        <div class="session-block">
          <div class="content">
            <h2>Skill A – Evaluate Source</h2>
            <SkillBarChart v-bind:chart-styles="'test'" />
          </div>
        </div>
        <div class="session-block">
          <div class="content">
            <h2>Skill B – Lorem Ipsum</h2>
            <SkillBarChart v-bind:chart-styles="'test'" />
          </div>
        </div>
        <div class="session-block">
          <div class="content">
            <h2>Skill C – Lorem Ipsum</h2>
            <SkillBarChart v-bind:chart-styles="'test'" />
          </div>
        </div>
      </div> -->
      <h1 style="display: flex; justify-content: center;">Check for Understanding</h1>
      <ul class="session-container">
        <li class="session-block" v-if="mostMissed.length > 0">
          <div>
            <h2 style="margin: 0">Most Missed Question{{mostMissed.length > 1 ? 's' : ''}}</h2>
            <p style="margin: 0; margin-top: 0.5rem;">by number of attempts</p>
          </div>
          <h3 v-for="question in mostMissed" :key="question">
            Question {{question + 1}}
          </h3>
        </li>
        <li v-for="(question, index) in questionList" :key="index" class="session-block">
          <h2>Question {{index + 1}}</h2>
          <QuestionBarChart 
              v-bind:chart-styles="'test'" 
              :attemptsList=question
            />
        </li>
      </ul>
      <h1 v-if="groupCount" style="display: flex; justify-content: center;">Teams</h1>
      <ul v-if="groupCount" class="session-container">
        <li v-for="(group, index) in groupList" :key="index" class="session-block">
          <div class="team-analytics">
            <h2>Team {{ group.groupName }}</h2>
            <!-- <h3>{{ group.groupName }}</h3> -->
            <ul class="students-inline">
              <li
                v-for="student in attendance[index].studentList"
                class="student-name-item"
                style="white-space: pre-line"
                :key="student.studentId"
              >
                {{ student.studentName }}
              </li>
            </ul>
             <!-- <h1 class="points">{{group.score}}pts</h1> -->
          </div>
          <div class="session-stats flex-container-row stretch"> 
            <h4 class="time">MCQ Time</h4>
            <h4 class="points">{{timeParse(group.taskTimes[0])}} mins</h4>
          </div>
          <div class="session-stats flex-container-row stretch"> 
            <h4 class="time">CFU Time</h4>
            <h4 class="points">{{timeParse(group.taskTimes[1])}} mins</h4>
          </div>
          <div class="session-stats flex-container-row stretch"> 
            <h4 class="time">Bonus Time</h4>
            <h4 class="points">{{timeParse(group.taskTimes[2])}} mins</h4>
          </div>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import MainNavigation from "../components/MainNavigation.vue";
import AverageCFUCompletion from "../components/AverageCFUCompletion.vue";
import RadialChart from "../components/RadialChart.vue";
import AverageBarChart from "../components/AverageBarChart.vue";
import QuestionBarChart from "../components/QuestionBarChart.vue";
// import SkillBarChart from "../components/SkillBarChart.vue";
import ClassItem from "../components/ClassItem.vue";
import Loader from "../components/Loader.vue";
import LoaderError from "../components/LoaderError.vue";

export default {
  name: "SessionAnalytics",
  components: {
    MainNavigation,
    AverageCFUCompletion,
    RadialChart,
    AverageBarChart,
    QuestionBarChart,
    // SkillBarChart,
    ClassItem,
    Loader,
    LoaderError
  },
  props: ["name", "routeIndex"],
  data: function() {
    return {
      isShowA: false,
      isShowB: false,
      isShowC: false
    }
  },
  computed: {
    allClasses() {
      return this.$store.state.allClasses;
    },
    currentSession() {
      return this.$store.state.pastSessionData;
    },
    currentClass() {
      const result = this.$store.state.allClasses.filter((response) => {
        return response.classInfo.nickname === this.$route.params.name
      });
      return result[0];
    },
    allStudents() {
      return this.$store.state.studentList;
    },
    pastSessions() {
      return this.$store.state.pastSessions;
    },
    storyBoxName() {
      return this.$filters.storyName(this.currentSession.sessionSettings.storyboxId);
    },
    levelName() {
      return this.$filters.levelName(this.currentSession.sessionSettings.levelId);
    },
    attendance() {
      const result = this.currentSession.attendance.filter((response) => {
        return response.studentList.length > 0     
      });
      return result;
    },
    groupList() {
      const result = this.currentSession.groupList.filter((response) => {
        return response.studentList.length > 0     
      });
      return result;
    },
    questionList() {
      var questions = [[0,0,0,0],[0,0,0,0],[0,0,0,0],[0,0,0,0],[0,0,0,0]];
      this.currentSession.groupList.forEach(group => {
        if (group.studentList.length != 0)
        {
          var groupAttemptsList = [4,4,4,4,4];
          group.cfuAnsweredList.forEach(cfuIdx => {
            var count = group.cfuList.filter(x => x == cfuIdx).length;
            if (count > 4) count = 4;
            groupAttemptsList[cfuIdx] = count;
          });
          groupAttemptsList.forEach((attemptCount, questionIdx) => {
            questions[questionIdx][attemptCount - 1]++;
          });
        }
      });
      return questions;
    },
    mostMissed() {
      var mostMissedList = [0,0,0,0,0];
      this.questionList.forEach((question, idx) => {
        var sum = 0;
        question.forEach((attempts, i) => {
          sum += attempts * i;
        });
        mostMissedList[idx] = sum;
      });
      var max = Math.max(...mostMissedList);
      var mostMissedFinal = [];
      mostMissedList.forEach((val, i) => {
        if (val == max) {
          mostMissedFinal.push(i);
        }
      });
      if (mostMissedFinal.length == 5) return [];
      else return mostMissedFinal;
    },
    groupCount() {
      return this.groupList.length > 0;
    },
    taskProgressObject(){
      var arr = [];
      this.groupList.forEach((item) =>
        arr.push(item.taskTimes)
      );
      return arr;
    }
  },
  methods: {
    getDate: function(timestamp){
      return this.$filters.getDate(timestamp);
    },
    getTime: function(timestamp){
      return this.$filters.getTime(timestamp);
    },
    timeParse: function(time) {
      return this.$filters.timeFormat(time);
    }
  },
  mounted () {
    document.body.classList.add('session-analytics')
  },
  unmounted () {
    document.body.classList.remove('session-analytics')
  }
}
</script>

<style lang="scss">
  .session-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    &.group-list {
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 20px;
      grid-row-gap: 20px;
    }
    @media only screen and (max-width: 1024px) {
      grid-template-columns: repeat(2, minmax(300px, 1fr));
    }
    @media only screen and (max-width: 768px) {
      grid-template-columns: repeat(1, minmax(400px, 1fr));
    }
  }
  ul.session-container {
    padding: 0;
  }
  // h1 {
  //   text-align: center;
  // }
  .static.session-block.class-item {
    &:before {
      width: 6em;
      height: 6em;
      background-size: 6em;
      margin-right: 0;
      margin-bottom: 1em;
    }
  }
  .session-block {
    @include card-styles;
    box-shadow: unset;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    background: $white!important;
    min-height: 250px;
    * {
      text-align: center;
    }
    h1.hero {
      font-size: 3em;
    }
    h2 {
      margin-top: 0.75rem;
      /*margin-bottom: 0;*/
    }
    p {
      &.date-time {
        font-size: 0.85em;
      }
    }
    &.class-card{
      border-top: 12px solid $blue;
      margin-top: 0px;
    }
    .session-stats {
      width: 85%;
      margin: auto;
      display: flex;
      justify-content: space-between;
      // @media only screen and (max-device-width: 1024px) {
      //   flex-direction: column;
      // }
    }
  }

  .session-analytics .main-wrapper {
    max-width: 100%;
  }

  .team-analytics {
    width: 100%;
    h3 {
      margin-top: 0;
      font-weight: normal;
    }
    p {
      margin: 0.25em;
    }
    ul {
      display: inline;
      padding: 0px;
      li {
        display: inline;
        list-style-type: none;
        margin-right: 0.5em;
        font-size: 0.9em;
        &:after {
          content: ",";
          display: inline;
        }
        &:last-of-type {
          &:after {
            display: none;
          }
        }
      }
    }
    .score-drawer {
      display: none;
      margin-top: 2em;
      text-align: left;
      strong {
        border-bottom: 2px solid $brown;
      }
    }
    .student-score-container {
      display: none;
      padding-top: 1em;
      &.close { display: none; }
      &.open { display: block; }
      .student-data-block {
        display: flex;
        align-content: center;
        justify-content: space-between;
        p {
          margin: 0;
          padding-bottom: 0.5em;
        }
      }
    }
  }

</style>